<template>
  <div id="app" v-cloak>
    <transition :name="transitionName">
      <keep-alive :include="keepAlive">
        <router-view class></router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
// import navBar from "@/components/NavBar";
import { setStore, getStore } from "@/utils/mUtils";
import { removeStore } from "./utils/mUtils";
// import { getLocation } from "@/utils/mapUtils";
// getLocation();
export default {
  name: "App",
  data() {
    return {
      keepAlive: ["home", "my"], //需要缓存的页面 例如首页
      transitionName: "slide-right", //初始过渡动画方向
    };
  },
  components: {},
  created() {
    console.log(
      `%c 大有阳光 %c V1.025.10.27.1714 %c 趣味测评占位dom`,
      "padding: 2px 1px; border-radius: 3px 0 0 3px; color: #fff; background: #606060; font-weight: bold;",
      "padding: 2px 1px; border-radius:  0 ; color: #fff; background: #1e80ff; font-weight: bold;",
      "padding: 2px 1px; border-radius: 0 3px 3px 0; color: #fff; background: #42c02e; font-weight: bold;"
    );
    // 获取状态栏高度
    this.bridgeStatusBar();
  },
  mounted() {},
  watch: {},
  methods: {},
};
</script>
<style lang="scss"></style>
<style>
[v-cloak] {
  display: none;
}
.Router {
  position: absolute;
  /* height: 100%; */
  transition: all 0.377s ease;
  will-change: transform;
  /* top: 0; */
  backface-visibility: hidden;
  perspective: 1000;
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
#app {
  background: #fff;
}
#app #welcome_img {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  object-fit: cover;
}
</style>
<style>
.ql-editor.ql-blank::before {
  color: #b2b2b2;
  font-style: normal;
}
.van-image.van-image-preview__image--vertical {
  width: 750px;
}
.van-image.van-image-preview__image--vertical img {
  width: 750px;
}
.van-list__error-text,
.van-list__finished-text,
.van-list__loading {
  color: #fff;
}
* {
  word-wrap: break-word;
  word-break: break-all;
}
.van-list__error-text,
.van-list__finished-text,
.van-list__loading {
  color: #333;
}
</style>
